// https://dev.to/dmtrkovalenko/the-neatest-way-to-handle-alert-dialogs-in-react-1aoe
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { type ReactElement } from 'react';

export interface AlertOptions {    
    title: string;
    message: string;
    agreeButtonTitle?: string;    
    destructive?: boolean;
    closeButtonTitle: string;
}

interface AlertProps extends AlertOptions {
    open: boolean;
    onAgreeClick?: () => void;
    onCloseCLick: () => void;
}

const Alert = ({ open, title, message, agreeButtonTitle, onAgreeClick: onAgree, destructive, closeButtonTitle, onCloseCLick: onClose }: AlertProps): ReactElement => {    
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-title"
            aria-describedby="alert-description"
        >
            <DialogTitle id="alert-title" sx={{ fontWeight: 700 }}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-description">
                    <span dangerouslySetInnerHTML={{ __html: message }}/>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{closeButtonTitle}</Button>    
                {onAgree &&
                    <Button color={destructive ? "error" : "secondary"} onClick={onAgree}>{agreeButtonTitle}</Button>
                }
            </DialogActions>
        </Dialog>
    );
}

export default Alert;